module.exports = __webpack_public_path__ + "img/keephimhot.252a446.png";